import { type GatsbyLinkProps } from 'gatsby'
import React, {
  type AnchorHTMLAttributes,
  type ElementType,
  type FC,
} from 'react'

export type LinkUnstyledProps = {
  as?: 'a' | ElementType
} & (AnchorHTMLAttributes<HTMLAnchorElement> | GatsbyLinkProps<any>)
export const LinkUnstyled: FC<LinkUnstyledProps> = ({
  children,
  as: LinkContainer = 'a',
  ...props
}) => <LinkContainer {...props}>{children}</LinkContainer>
